export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esta acción eliminará permanentemente el activo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Estás seguro de que quieres continuar?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sí"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ya no verás este activo en tu lista."])}
}